module.exports = __webpack_public_path__ + "static/icons/icon-accommodation-a1d1140d12804e568afd389f1efabcb6.svg";